import React from "react";
import removeImg from "assets/svgs/close.svg";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

const SlidersArray = ({ sliders, setSliders }) => {
  const { formatMessage } = useIntl();
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newSlidersArray = sliders?.map((slider, index) => {
      if (index !== id) return slider;

      // make an object with locals inside the big one
      const inputName = name?.split(".")?.[0];
      const local = name?.split(".")?.[1];

      if (local) {
        return {
          ...slider,
          [inputName]: {
            ...slider?.[inputName],
            [local]: value,
          },
        };
      }

      return { ...slider, [name]: value };
    });

    setSliders(newSlidersArray);
  };

  const removeSlider = (sliderId) => {
    const newSliders = sliders?.filter((slider, index) => index !== sliderId);
    setSliders(() => newSliders);
  };

  const addSlider = () => {
    setSliders(() => [
      ...(sliders || []),
      {
        title: {},
        description: {},
        type: "", //
      },
    ]);
  };

  return (
    <div className="form-group branches sliders">
      <Row style={{ rowGap: "10px" }}>
        <h5>
          <FormattedMessage id={"categories"} />
        </h5>

        {sliders?.map((slider, index) => {
          return (
            <Row key={index} className="">
              <div className="add-multi-component">
                <Row style={{ rowGap: "10px" }}>
                  <button
                    type="button"
                    onClick={() => removeSlider(index)}
                    className="removeImg"
                    aria-label="remove"
                  >
                    <img src={removeImg} alt="" />
                  </button>

                  <Row>
                    <Row>
                      <Row>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"title"} /> ({" "}
                              <FormattedMessage id={"arabic-language"} /> )
                            </h5>
                            <input
                              type="title"
                              name={"title.ar"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.title.ar}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"title"} /> ({" "}
                              <FormattedMessage id={"english-language"} /> )
                            </h5>
                            <input
                              type="title"
                              name={"title.en"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.title.en}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"description"} /> ({" "}
                              <FormattedMessage id={"arabic-language"} /> )
                            </h5>
                            <textarea
                              type="description"
                              name={"description.ar"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.description.ar}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"description"} /> ({" "}
                              <FormattedMessage id={"english-language"} /> )
                            </h5>
                            <textarea
                              type="description"
                              name={"description.en"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.description.en}
                            />
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"type"} />
                            </h5>
                            <select
                              name="type"
                              className="form-control form-outline form-select"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.type}
                            >
                              <option value="">
                                -- {formatMessage({ id: "selectType" })} --
                              </option>
                              <option value="objection">
                                {formatMessage({ id: "objection" })}
                              </option>
                              <option value="developerrequest">
                                {formatMessage({ id: "developerRequest" })}
                              </option>
                            </select>
                          </div>
                        </Col>
                      </Row>
                    </Row>
                  </Row>
                </Row>
              </div>
            </Row>
          );
        })}

        <Row>
          <Col lg={3} xs={12} className="text-left">
            <button
              type="button"
              className="btn btn-green add_new_section__"
              onClick={() => {
                addSlider();
              }}
            >
              <FormattedMessage id={"addFaqs"} />
            </button>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default SlidersArray;
